import Vue from 'vue'
import Vuex from 'vuex'
// import axios from 'axios'
// import qs from 'qs'
import crypt from './cache'
import _ from 'lodash'

import {
  SET_CACHE,
  SET_GLOBAL_LOADING,
  SET_VIEWPORT,
  SET_TOUCH,
  SET_NETWORK_STATUS,
  SET_PAGE,
  SET_SUB_PAGE,
  SET_HOME_CONTENT,
  SET_PROCESSINGS_EXCERPT,
  SET_INTERNALS_EXCERPT,
  SET_TEXT_GALLERY,
  SET_PICTURE_GALLERY
} from './mutation-types'

Vue.use(Vuex)

export default new Vuex.Store({
  state: require('./contents.json'),
  getters: {
    cache: state => state.cache,
    loading: state => state.loading,
    viewport: state => state.viewport,
    touch: state => state.touch,
    page: state => (lang, name, type) => {
      if (typeof type === 'undefined') return state.pages[lang][name]
      return state.pages[lang][`${name}Subs`][type]
    },
    processingsExcerpts: state => lang => {
      return state.processingsExcerpts[lang]
    },
    internalsExcerpts: state => lang => {
      return state.internalsExcerpts[lang]
    },
    textGallery: state => ({ lang, id }) => {
      return state.textGalleries[lang][id]
    },
    pictureGallery: state => ({ lang, id }) => {
      return state.pictureGalleries[lang][id]
    }
  },
  mutations: {
    [SET_CACHE] (state, { status, mutation, data }) {
      if (status !== 200) return
      state.cache = _.uniq(_.concat(state.cache, crypt({ mutation, data })))
    },
    [SET_GLOBAL_LOADING] (state, status) {
      Vue.set(state, 'loading', status)
    },
    [SET_VIEWPORT] (state, viewport) {
      Vue.set(state, 'viewport', viewport)
    },
    [SET_TOUCH] (state, touch) {
      Vue.set(state, 'touch', true)
    },
    [SET_PAGE] (state, { pageName, lang, data }) {
      Vue.set(state.pages[lang], pageName, data)
    },
    [SET_SUB_PAGE] (state, { pageName, lang, type, data }) {
      Vue.set(state.pages[lang][`${pageName}Subs`], type, data)
    },
    [SET_NETWORK_STATUS] (state, data) {
      state.networkStatus = data
    },
    [SET_HOME_CONTENT] (state, { lang, data }) {
      state.homeContent[lang] = data
    },
    [SET_PROCESSINGS_EXCERPT] (state, { lang, data }) {
      Vue.set(state.processingsExcerpts, lang, data)
    },
    [SET_INTERNALS_EXCERPT] (state, { lang, data }) {
      Vue.set(state.internalsExcerpts, lang, data)
    },
    [SET_TEXT_GALLERY] (state, { lang, id, data }) {
      Vue.set(state.textGalleries[lang], id, data)
    },
    [SET_PICTURE_GALLERY] (state, { lang, id, data }) {
      Vue.set(state.pictureGalleries[lang], id, data)
    }
  },
  actions: {
    async loadPageData ({ commit, dispatch, getters }, { pageName, lang, type }) {

    },
    async loadSubPageData ({ commit, getters }, { pageName, lang, type }) {

    },
    async loadHomeContent ({ commit, getters }, { lang }) {

    },
    async loadProcessingsExcerpts ({ commit, getters }, { lang, filter }) {

    },
    async loadInternalsExcerpts ({ commit, getters }, { lang, filter }) {

    },
    async loadTextGallery ({ commit, getters }, { lang, id }) {

    },
    async loadPictureGallery ({ commit, getters }, { lang, id }) {

    }
  }
})
